module.exports = __webpack_public_path__ + "static/media/anterghat-gate.3cacb63c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anterghat-gate.jpeg
// module id = 532
// module chunks = 0